import React from 'react';
import map from 'lodash/map';
import classnames from 'classnames';
import { Button, Image } from 'shared/lib/SureDesignSystem';
import LazyLoad from 'react-lazyload';
import FAQSection from '../FAQSection';
import Footer from '../Footer';
import styles from './LandingClaims.module.css';
import { isWebPSupported } from 'shared/lib/utils';

const steps = [
  {
    title: 'Step 1: Oops!',
    description:
      'Your brand new iPhone slips through your fingers and breaks as you get out of the car.',
    image: require('./assets/steps/iphone.svg'),
  },
  {
    title: 'Step 2: Claim It',
    description: 'Open the SURE app and tap on “Claims.”',
    image: require('./assets/steps/claim_it.png'),
    webp: require('./assets/steps/claim_it.webp'),
  },
  {
    title: 'Step 3: Tell Us Everything',
    description:
      'Submit a detailed account of loss, giving as much detail as you can about what happened.',
    image: require('./assets/steps/tell_us.png'),
    webp: require('./assets/steps/tell_us.webp'),
  },
  {
    title: 'Step 4: Hit “Submit”',
    description:
      'Once you submit your claim, you’ll get a notification via email that it is being processed.',
    image: require('./assets/steps/submit.png'),
    webp: require('./assets/steps/submit.webp'),
  },
  {
    title: 'Step 5: Get Reimbursed',
    description:
      'We work to be efficient and fast, to get reimbursement from your carrier to you via mail as quickly as possible.',
    image: require('./assets/steps/reimbursed.png'),
    webp: require('./assets/steps/reimbursed.webp'),
  },
];

function LandingClaims() {
  return (
    <div className={styles.wrapper}>
      <div
        className={classnames(
          styles.heroSection,
          isWebPSupported
            ? styles.heroSectionBackgroundWebp
            : styles.heroSectionBackground
        )}
      >
        <div className={styles.heroSection_container}>
          <h1 className={styles.heroSection_title}>
            You’re covered. Here’s how.
          </h1>
          <p className={styles.heroSection_description}>
            When something unexpected happens, we’re right there to help. Let us
            walk you through what happens when you file a claim.
          </p>
          <Button
            to="/account/claims"
            className={styles.heroSection_button}
            secondary
          >
            Submit a claim
          </Button>
        </div>
      </div>

      <div className={styles.stepsSection}>
        <div className={styles.stepsSection_container}>
          <div className={styles.stepsSection_steps}>
            {map(steps, (step, i) => (
              <div key={i} className={styles.stepsSection_step}>
                <div className={styles.stepsSection_stepImageWrapper}>
                  <LazyLoad height={290} once>
                    <Image
                      src={step.image}
                      webp={step.webp}
                      className={styles.stepsSection_stepImage}
                    />
                  </LazyLoad>
                  <div className={styles.stepsSection_stepImageLine} />
                </div>
                <div className={styles.stepsSection_stepContent}>
                  <h3 className={styles.stepsSection_stepTitle}>
                    {step.title}
                  </h3>
                  <p className={styles.stepsSection_stepDescription}>
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.leadGenSection}>
        <div className={styles.leadGenSection_container}>
          <h2 className={styles.leadGenSection_title}>
            Did you experience a loss?
          </h2>
          <Button
            to="/account/claims"
            className={styles.leadGenSection_button}
            secondary
          >
            Submit a claim
          </Button>
        </div>
      </div>
      <FAQSection />
      <Footer />
    </div>
  );
}

export default LandingClaims;
